import { Weekday } from '../model'

export const getLocaleKeyFromDayNumber = (day: Weekday): string => {
  const displayNames = {
    0: 'preferredDay.weekday.0',
    1: 'preferredDay.weekday.1',
    2: 'preferredDay.weekday.2',
    3: 'preferredDay.weekday.3',
    4: 'preferredDay.weekday.4',
    5: 'preferredDay.weekday.5',
    6: 'preferredDay.weekday.6',
  }

  return displayNames[day] ?? ''
}

export const getUppercaseDayNameFromDayNumber = (day: Weekday): string => {
  const displayNames = {
    0: 'SUNDAY',
    1: 'MONDAY',
    2: 'TUESDAY',
    3: 'WEDNESDAY',
    4: 'THURSDAY',
    5: 'FRIDAY',
    6: 'SATURDAY',
  }

  return displayNames[day]
}

export const getDayNumberFromUppercaseDay = (day: string): Weekday => {
  const displayNames = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
  }

  return displayNames[day]
}
